module.exports = __webpack_public_path__ + "img/av-desktop-default.c920efb7.png";